import React from 'react';
import { useIntl } from 'umi';
import { importImg } from '@/pages/home/components/RegionSelect/utils';
import { gotoIntelligenceGame } from '@/pages/home/utils/utils';
import GameImage from '@/pages/home/components/GameImage';
import { getGameTypeImgType } from '@/pages/home/pages/home/Explore/_config/common';

export default function Competitor(props: any) {
  const { competitorList = [] } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  // 跳转游戏详情overview
  const gotoOverview = (item: any) => {
    const { unified_id, entity_type } = item;
    gotoIntelligenceGame(unified_id, entity_type, 'overview');
  };

  return (
    <>
      {competitorList?.length > 0 && (
        <>
          <div className="home-search-compet">
            {formatMessage({ id: 'dbh_competitor' })}
          </div>
          <div className="competitor">
            {competitorList?.map((item: any, index: any) => {
              return (
                <div
                  key={index}
                  className="competitor-item"
                  onClick={() => {
                    gotoOverview(item);
                  }}
                >
                  <GameImage
                    className={getGameTypeImgType('mobile')}
                    src={item.cover}
                  />
                  <div className="competitor-item-message">
                    <div className="competitor-item-title">{item.name}</div>
                    <div className="competitor-item-felx">
                      <img
                        className="competitor-item-coun"
                        src={importImg(`${item.country?.toLowerCase()}`)}
                      />
                      <span className="competitor-item-text">{item.Publisher}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}
